<page-grid [gridConfig]="tripsGrid"/>